import Layout from "@/components/Layout";
import HolidaysList from "@/components/HolidaysList";

export default function Holidays() {
  return (
    <Layout>
      <div className="mb-6">
        <div className="text-xs uppercase tracking-[0.2em] text-slate-400 mb-2">School calendar</div>
        <h1 className="text-3xl font-bold text-slate-900 dark:text-slate-100" style={{ fontFamily: "Outfit" }}>Holidays</h1>
        <p className="text-slate-500 dark:text-slate-400 mt-1">Upcoming and past holidays for this year.</p>
      </div>
      <HolidaysList />
    </Layout>
  );
}
